import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

/**
 * Loading placeholder (shell/navigation redesign §4) — hand-rolled, no dependency.
 *
 * Render skeletons **at the final geometry** of the content they stand in for
 * (§3.6: the sidebar draws skeleton rows while `caps.isLoading`), so resolving
 * data swaps content in without a layout shift (R9).
 *
 * `aria-hidden` + `role="presentation"`: the placeholder itself is noise for a
 * screen reader — announce the loading state on the region that owns it
 * (`aria-busy`), not on every bar.
 */
export function Skeleton({ className, ...props }: ComponentPropsWithoutRef<"div">) {
  return (
    <div
      data-slot="skeleton"
      role="presentation"
      aria-hidden
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}
